import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { StateValue } from 'xstate';
import type { RootState } from '@/app/store';
import type { OrderMachineContext } from '@/machines/orderMachine';
import { logoutSuccess } from '@/features/auth/authSlice';

export interface SupervisorSnapshotPayload {
  readonly value: StateValue;
  readonly context: OrderMachineContext;
  readonly loginPromptSent: boolean;
}

interface SupervisorState {
  readonly snapshot: SupervisorSnapshotPayload | null;
}

const initialState: SupervisorState = {
  snapshot: null,
};

const supervisorSlice = createSlice({
  name: 'supervisor',
  initialState,
  reducers: {
    setSnapshot: (state, action: PayloadAction<SupervisorSnapshotPayload>) => {
      state.snapshot = action.payload;
    },
    clearSupervisor: (state) => {
      state.snapshot = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutSuccess, (state) => {
      state.snapshot = null;
    });
  },
});

export const { setSnapshot, clearSupervisor } = supervisorSlice.actions;

export const selectSupervisorSnapshot = (state: RootState) => state.supervisor.snapshot;

export type SupervisorSliceState = SupervisorState;

export default supervisorSlice.reducer;
